export const TRASH_ICON = "/img/assistant/icons/trash.svg";
export const EDIT_ICON = "/img/assistant/icons/edit.svg";
export const PLUS_ICON = "/img/assistant/icons/plus.svg";
export const MINUS_ICON = "/img/assistant/icons/minus.svg";
export const INFO_ICON = "/img/assistant/icons/info.svg";
export const CANCEL_ICON = "/img/assistant/icons/cancel.svg";
export const MORE_ICON = "/img/assistant/icons/more.svg";
export const UNDO_ICON = "/img/assistant/icons/undo.svg";
export const BOT_ICON = "/icons/bot.svg";
export const BOT_WHITE_ICON = "/icons/bot_white.svg";
export const PAXAI_ICON = "/img/assistant/icons/paxAI.svg";
export const ARROW_LEFT_ICON = "/img/assistant/icons/arrow_left.svg";
export const ARROW_LEFT_DARK_ICON = "/img/assistant/icons/arrow_left_dark.svg";
export const ARROW_RIGHT_ICON = "/img/assistant/icons/arrow_right.svg";
export const UPLOAD_ICON = "/img/assistant/icons/upload.svg";
export const SAVE_ICON = "/img/assistant/icons/save.svg";
export const DOWNLOAD_ICON = "/img/assistant/icons/download.svg";
export const DOWNLOAD_DARK_ICON = "/img/assistant/icons/download_dark.svg";
export const CLOCK_ICON = "/img/assistant/icons/clock.svg";
export const RESET_ICON = "/img/assistant/icons/reset.svg";
export const RESET_ALT_ICON = "/img/assistant/icons/reset_alt.svg";
export const MAP_ICON = "/img/assistant/icons/map.svg";
export const CHART_ICON = "/img/assistant/icons/chart.svg";
export const TABLE_ICON = "/img/assistant/icons/table.svg";
export const MERGE_ICON = "/img/assistant/icons/merge.svg";
export const SPLIT_ICON = "/img/assistant/icons/split.svg";
export const CLOSE_ICON = "/img/assistant/icons/close.svg";
export const CHECK_ICON = "/img/assistant/icons/check.svg";
export const ADD_ROAD_ICON = "/img/assistant/icons/add_road.svg";
export const CHEVRON_DOWN_ICON = "/img/assistant/icons/chevron_down.svg";
export const CHEVRON_UP_ICON = "/img/assistant/icons/chevron_up.svg";
export const CHEVRON_LEFT_ICON = "/img/assistant/icons/chevron_left.svg";
export const CHEVRON_RIGHT_ICON = "/img/assistant/icons/chevron_right.svg";
export const TRANSITIONS_ICON = "/img/assistant/icons/transitions.svg";
export const ZOOMIN_ICON = "/img/assistant/icons/zoomin.svg";

export const APPLICATIONS_ICON = "/img/assistant/icons/applications.svg";
export const APPOVERVIEW_ICON = "/img/assistant/icons/appOverview.svg";
export const WINDOWS_ICON = "/img/assistant/icons/windows.svg";
export const INTERACTIONS_ICON = "/img/assistant/icons/interactions.svg";
export const TIME_BEFORE_ICON = "/img/assistant/icons/timeBefore.svg";
export const TIME_AFTER_ICON = "/img/assistant/icons/timeAfter.svg";
export const TIMELINE_DARK_ICON = "/img/assistant/icons/timeline_dark.svg";
export const TIMELINE_ICON = "/img/assistant/icons/timeline.svg";
export const SQUARE_LANDSCAPE_ICON = "/img/assistant/icons/square_landscape.svg";
export const FULLSCREEN_ICON = "/img/assistant/icons/fullscreen.svg";
export const FULLSCREEN_OFF_ICON = "/img/assistant/icons/fullscreen_off.svg";
export const FIT_SCREEN_ICON = "/img/assistant/icons/fit_screen.svg";
export const ROBOT_2_ICON = "/img/assistant/icons/robot_2.svg";
export const FILTER_ALT_ICON = "/img/assistant/icons/filter_alt.svg";
export const CATEGORY_ICON = "/img/assistant/icons/category.svg";
export const DONE_ALL_DARK_ICON = "/img/assistant/icons/done_all_dark.svg";
export const DONE_ALL_ICON = "/img/assistant/icons/done_all.svg";
export const JOIN_INNER_ALT_ICON = "/img/assistant/icons/join_inner_alt.svg";
export const SORTED_ARROW2_ICON = "/img/assistant/icons/sorted-arrow2.svg";
export const SORT_ARROW_ICON = "/img/assistant/icons/sort-arrow.svg";
export const SPEED_ICON = "/img/assistant/icons/speed.svg";
export const EXPLORE_ICON = "/img/assistant/icons/explore.svg";
export const VARIANTS_ICON = "/img/assistant/icons/variants.svg";
export const PIE_CHART_ICON = "/img/assistant/icons/pie_chart.svg";
export const NEXT_STEP_ICON = "/img/assistant/icons/next_step.svg";
export const OCCURRENCE_ICON = "/img/assistant/icons/occurrence.svg";
export const LAYERS_CLEAR_ICON = "/img/assistant/icons/layers_clear.svg";
export const SAVINGS_ICON = "/img/assistant/icons/savings.svg";
export const TEXT_FIELDS_ICON = "/img/assistant/icons/text_fields.svg";
export const CONTENT_PASTE_ICON = "/img/assistant/icons/content_paste.svg";
export const SCHEDULE_ICON = "/img/assistant/icons/schedule.svg";
export const APPS_DARK_ICON = "/img/assistant/icons/apps_dark.svg";
export const WARNING_ICON = "/img/assistant/icons/warning.svg";
export const CHECK_DARK_ICON = "/img/assistant/icons/check_dark.svg";
export const CHECKBOX_SELECTED_WHITE_ICON = "/img/assistant/icons/checkbox_selected_white.svg";
export const CHECKBOX_ICON = "/img/assistant/icons/checkbox.svg";
export const PREVIEW_ICON = "/img/assistant/icons/preview.svg";
export const OPEN_IN_NEW_ICON = "/img/assistant/icons/open_in_new.svg";
export const COPY_ICON = "/img/assistant/icons/copy.svg";
export const COPY_DARK_ICON = "/img/assistant/icons/copy_dark.svg";
export const SHUFFLE_ICON = "/img/assistant/icons/shuffle.svg";
export const KEYBOARD_ENTER_DARK_ICON = "/img/assistant/icons/keyboard_enter_dark.svg";
export const HOME_ICON = "/img/assistant/icons/home.svg";
export const HELP_ICON = "/img/assistant/icons/help.svg";
export const LICENSE_ICON = "/img/assistant/icons/license.svg";
export const LANDSCAPE_ICON = "/img/assistant/icons/landscape.svg";
export const MAIL_ICON = "/img/assistant/icons/mail.svg";
export const MAIL_DARK_ICON = "/img/assistant/icons/mail_dark.svg";
export const SHARE_ICON = "/img/assistant/icons/share.svg";
export const TREEMAP_ICON = "/img/assistant/icons/treemap.svg";
export const ERASE_ICON = "/img/assistant/icons/erase.svg";